<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>促销活动</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form class="user-search" :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch">
      <el-form-item label="活动规则id" prop="thresholdCoupon">
        <el-input
          v-model="queryParams.thresholdCoupon"
          placeholder="请输入活动规则id"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="关联门店ID" prop="storeId">
        <el-input
          v-model="queryParams.storeId"
          placeholder="请输入关联到关联门店ID"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <!--      <el-form-item label="用于活动的备注信息" prop="note">-->
      <!--        <el-input-->
      <!--          v-model="queryParams.note"-->
      <!--          placeholder="请输入用于活动的备注信息"-->
      <!--          clearable-->
      <!--          @keyup.enter.native="handleQuery"-->
      <!--        />-->
      <!--      </el-form-item>-->
      <el-form-item label="优惠券发放方式" prop="discount">
        <el-select v-model="queryParams.discount" ref="select" placeholder="请选择优惠券发放方式" multiple>
          <el-option
            v-for="item in optionsdiscount"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="优惠券发放方式" prop="discount">
        <el-select v-model="queryParams.discount" ref="select" placeholder="请选择优惠券发放方式" multiple>
          <el-option
            v-for="item in optionsdiscount"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

<!--      <el-form-item label="活动开始的时间" prop="startTime">-->
<!--        <el-date-picker clearable-->
<!--                        v-model="queryParams.startTime"-->
<!--                        type="date"-->
<!--                        value-format="yyyy-MM-dd"-->
<!--                        placeholder="请选择活动开始的时间">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="活动结束的时间" prop="endTime">-->
<!--        <el-date-picker clearable-->
<!--                        v-model="queryParams.endTime"-->
<!--                        type="date"-->
<!--                        value-format="yyyy-MM-dd"-->
<!--                        placeholder="请选择活动结束的时间">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="优惠对象，可以是all" prop="target">-->
<!--        <el-input-->
<!--          v-model="queryParams.target"-->
<!--          placeholder="请输入优惠对象，可以是all"-->
<!--          clearable-->
<!--          @keyup.enter.native="handleQuery"-->
<!--        />-->
<!--      </el-form-item>-->
      <!--      <el-form-item label="是否开启周期活动，可以是布尔值" prop="periodic">-->
      <!--        <el-input-->
      <!--          v-model="queryParams.periodic"-->
      <!--          placeholder="请输入是否开启周期活动，可以是布尔值"-->
      <!--          clearable-->
      <!--          @keyup.enter.native="handleQuery"-->
      <!--        />-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="周期活动的起始时间" prop="periodStartTime">-->
      <!--        <el-date-picker clearable-->
      <!--          v-model="queryParams.periodStartTime"-->
      <!--          type="date"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="请选择周期活动的起始时间">-->
      <!--        </el-date-picker>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="周期活动的结束时间" prop="periodEndTime">-->
      <!--        <el-date-picker clearable-->
      <!--          v-model="queryParams.periodEndTime"-->
      <!--          type="date"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="请选择周期活动的结束时间">-->
      <!--        </el-date-picker>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="会员是否获得积分的标识，可以是布尔值" prop="earnPoints">-->
      <!--        <el-input-->
      <!--          v-model="queryParams.earnPoints"-->
      <!--          placeholder="请输入会员是否获得积分的标识，可以是布尔值"-->
      <!--          clearable-->
      <!--          @keyup.enter.native="handleQuery"-->
      <!--        />-->
      <!--      </el-form-item>-->
      <el-form-item label="活动名称" prop="activityName">
        <el-input
          v-model="queryParams.activityName"
          placeholder="请输入活动名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
<!--      <el-form-item label="活动的创建人信息" prop="createdBy">-->
<!--        <el-input-->
<!--          v-model="queryParams.createdBy"-->
<!--          placeholder="请输入活动的创建人信息"-->
<!--          clearable-->
<!--          @keyup.enter.native="handleQuery"-->
<!--        />-->
<!--      </el-form-item>-->
      <!--      <el-form-item label="活动的创建时间" prop="createdTime">-->
      <!--        <el-date-picker clearable-->
      <!--          v-model="queryParams.createdTime"-->
      <!--          type="date"-->
      <!--          value-format="yyyy-MM-dd"-->
      <!--          placeholder="请选择活动的创建时间">-->
      <!--        </el-date-picker>-->
      <!--      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['system:activity:add']"
        >新增
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['system:activity:edit']"
        >修改
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['system:activity:remove']"
        >删除
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['system:activity:export']"
        >导出
        </el-button>
      </el-col>
<!--      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>-->
    </el-row>

    <el-table v-loading="loading" :data="activityList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column label="主键" align="center" prop="activityId"/>
      <!--      <el-table-column label="满额表和关联的优惠券ID" align="center" prop="thresholdCoupon"/>-->
      <el-table-column label="用于活动的名称或标题" align="center" prop="activityName"/>

      <el-table-column label="关联到关联门店ID" align="center" prop="storeId"/>
      <el-table-column label="活动备注" align="center" prop="note"/>

      <el-table-column label="活动类型大类" align="center" prop="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type==='vip_active'">会员活动</span>
          <span v-if="scope.row.type==='specialActivity'">特价活动</span>
          <span v-if="scope.row.type==='discount'">折扣活动</span>
          <span v-if="scope.row.type==='offerCoinCoupons'">兑换券</span>
<!--          <span v-if="scope.row.type==='YeofferCoinCoupons'">液体兑换券</span>-->
<!--          <span v-if="scope.row.type==='offerYeCoinCoupons'">液体兑换券</span>-->
          <span v-if="scope.row.type==='offerFoldCoupons'">折扣券</span>
          <span v-if="scope.row.type==='offerMinusCoupons'">满减券</span>
          <span v-if="scope.row.type==='FullMinusActivity'">满减活动</span>
          <span v-if="scope.row.type==='fullFoldActivity'">满折活动</span>
          <span v-if="scope.row.type==='BuyActivity'">第n件促销</span>
          <!--          <span v-else>{{ scope.row.type }}</span>-->
        </template>
      </el-table-column>

      <el-table-column label="全场折扣/优惠券发放方式" align="center" prop="discount">
        <template slot-scope="scope">
          <span v-for="item in scope.row.discount.split(',')">
              <span v-if="item==='AfterLogin'">注册后发送，</span>
              <span v-if="item==='intoMiniProgram'">进入小程序就发送，</span>
              <span v-if="item==='AfterOpenDoor'">开门后发送，</span>
              <span v-if="item==='AfterBecameVIP'">成为会员后发送，</span>
              <span v-if="item==='AfterVipConsume'">会员消费后发送，</span>
              <span v-if="item==='AfterScanCode'">扫码、分享群领取，</span>
              <span v-if="item==='AfterRecharge'">充值后赠送，</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="活动开始的时间" align="center" prop="startTime" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动结束的时间" align="center" prop="endTime" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="优惠对象" align="center" prop="target">
        <template slot-scope="scope">
          <span v-if="scope.row.target=='all'">所有人</span>
          <span v-if="scope.row.target=='vip'">会员</span>
          <span v-if="scope.row.target=='novip'">非会员</span>
        </template>
      </el-table-column>
      <el-table-column label="是否开启周期活动" align="center" prop="periodic">

        <template slot-scope="scope">
          <span v-if="scope.row.periodic ==1">是</span>
          <span v-if="scope.row.periodic ==0">否</span>
        </template>
      </el-table-column>

      <el-table-column label="周期方式，例如按天、按周、按月等" align="center" prop="periodType"/>
      <el-table-column label="周期活动的起始时间" align="center" prop="periodStartTime" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.periodStartTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="周期活动的结束时间" align="center" prop="periodEndTime" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.periodEndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员是否获得积分的标识" align="center" prop="earnPoints">
        <template slot-scope="scope">
          <span v-if="scope.row.earnPoints ==1">是</span>
          <span v-if="scope.row.earnPoints ==0">否</span>
        </template>
      </el-table-column>

      <el-table-column label="活动的创建人信息" align="center" prop="createdBy"/>
      <el-table-column label="活动的创建时间" align="center" prop="createdTime" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['system:activity:edit']"
          >修改
          </el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['system:activity:remove']"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

<!--    <pagination-->
<!--      v-show="total>0"-->
<!--      :total="total"-->
<!--      :page.sync="queryParams.pageNum"-->
<!--      :limit.sync="queryParams.pageSize"-->
<!--      @pagination="getList"-->
<!--    />-->

    <!-- 添加或修改活动基本信息表对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body  :before-close="cancel">
      <el-form ref="form" :model="form" :rules="rules" label-width="180px">
        <!--        <el-form-item label="满额表和关联的优惠券ID" prop="thresholdCoupon">-->
        <!--          <el-input v-model="form.thresholdCoupon" placeholder="请输入满额表和关联的优惠券ID"/>-->
        <!--        </el-form-item>-->
        <el-form-item label="关联门店" prop="storeId"
                      v-if="form.type==='offerCoinCoupons' ||form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons' || form.type==='offerYeCoinCoupons'|| form.type==='YeofferCoinCoupons'">
          <el-select v-model="form.periodDay" ref="select" placeholder="请选择" multiple @change="DuiHuanChange">
            <el-option v-for="item in storeList" :key="String(item.id)" :label="item.name" :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关联门店" prop="storeId" v-else>
          <el-select v-model="form.storeId" ref="select" placeholder="请选择" multiple @change="DuiHuanChange">
            <el-option v-for="item in storeList" :key="String(item.id)" :label="item.name" :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="活动标题" prop="activityName">
          <el-input v-model="form.activityName" placeholder="请输入用于活动的名称或标题" style="width: 200px"/>
        </el-form-item>


        <el-form-item label="活动大类" prop="typeId">
          <el-select v-model="form.type" ref="select" placeholder="请选择活动大类" @change="reset()">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="全场折扣数" prop="discount" v-if="form.type==='discount'">
          <el-input v-model="QCZheKou" placeholder="请输入折扣数" style="width: 200px"/>
        </el-form-item>
        <el-form-item label="门槛单位" prop="discount"
                      v-if="form.type==='discount'">
          <el-select v-model="SelectYouHuiQuan" ref="select" placeholder="请选择优惠券门槛单位">
            <el-option
              v-for="item in SelectDanWeiList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="活动门槛" prop="discount" v-if="form.type==='discount'">
          <el-input v-model="QCMenKan" :placeholder="SelectYouHuiQuan == 1?'请输入金额':'请输入件数'"
                    style="width: 200px"/>
          {{ SelectYouHuiQuan == 1 ? '元' : '件' }}
        </el-form-item>


        <el-form-item label="优惠券发放方式" prop="discount"
                      v-if="form.type==='offerCoinCoupons' ||form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons' || form.type==='offerYeCoinCoupons'|| form.type==='YeofferCoinCoupons'">
          <el-select v-model="form.discount" ref="select" placeholder="请选择优惠券发放方式" multiple>
            <el-option
              v-for="item in optionsdiscount"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        form.discount.indexOf("AfterRecharge")-->

        <el-form-item label="充值优惠券赠送门槛" prop="discount"
                      v-if="form.discount.indexOf('AfterRecharge') != -1">
          <el-input v-model="form.periodType" placeholder="请输入金额" style="width: 200px"/>
          元
        </el-form-item>

        <el-form-item label="每个用户能领取该优惠券个数" prop="discount"
                      v-if="form.type==='offerCoinCoupons' ||form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons' || form.type==='offerYeCoinCoupons'|| form.type==='YeofferCoinCoupons'">
          <el-input v-model="form.updateBy" placeholder="请输入内容" style="width: 200px"/>
        </el-form-item>

        <el-form-item label="用券时间" prop="discount"
                      v-if="form.type==='offerCoinCoupons' ||form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons' || form.type==='offerYeCoinCoupons'|| form.type==='YeofferCoinCoupons'">

          <el-radio-group v-model="YonQuanTime" @input="Pop3QueDing">
            <el-radio :label="1">活动时间内可用</el-radio>
            <el-radio :label="2" style="margin-top: 10px">领取后等待
              <el-input v-model="LinQuHouWaitTime" placeholder="请输入天数" size="mini" style="width: 100px"/>
              天后可用，有效期
              <el-input v-model="YouXiaoQiTime" placeholder="请输入有效期" size="mini" style="width: 100px"/>
              天
            </el-radio>
            <el-radio :label="0" style="margin-top: 10px"> 领取后
              <el-input v-model="LinQuHouTime" placeholder="请输入天数" size="mini" style="width: 100px"/>
              天内可用
            </el-radio>
          </el-radio-group>

        </el-form-item>

        <el-form-item label="发行总量" prop="discount"
                      v-if="form.type==='offerCoinCoupons' ||form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons' || form.type==='offerYeCoinCoupons' || form.type==='YeofferCoinCoupons'">
          <el-input v-model="FaXinNumber" placeholder="请输入发行总量" style="width: 200px"/>
        </el-form-item>


        <el-form-item label="券面金额" prop="discount"
                      v-if="form.type == 'offerMinusCoupons' || form.type == 'offerFoldCoupons'">
          <el-input v-model="QuanMianMoney" :placeholder="form.type == 'offerMinusCoupons'?'请输入金额':'请输入折扣'"
                    style="width: 200px"/>
          {{ form.type == 'offerMinusCoupons' ? '元' : '折' }}
        </el-form-item>

        <el-form-item label="门槛单位" prop="discount"
                      v-if="form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons'">
          <el-select v-model="SelectYouHuiQuan" ref="select" placeholder="请选择优惠券门槛单位">
            <el-option
              v-for="item in SelectDanWeiList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="优惠券门槛" prop="discount"
                      v-if="form.type == 'offerMinusCoupons' || form.type == 'offerFoldCoupons'">
          <el-input v-model="MenKanMoney" :placeholder="SelectYouHuiQuan == 1?'请输入金额':'请输入件数'"
                    style="width: 200px"/>
          {{ SelectYouHuiQuan == 1 ? '元' : '件' }}
        </el-form-item>


        <el-form-item label="兑换数量" prop="discount"
                      v-if="form.type == 'offerCoinCoupons'">
          <el-input v-model="DuiHuanNumber" placeholder="请输入兑换数量" style="width: 200px"/>
          个
        </el-form-item>
        <el-form-item label="兑换体积" prop="discount"
                      v-if="form.type == 'YeofferCoinCoupons'">
          <el-input v-model="DuiHuanNumber" placeholder="请输入兑换体积" style="width: 200px"/>
          ml
        </el-form-item>

        <el-form-item label="兑换商品" prop="storeId" v-if="form.type == 'offerCoinCoupons'">
          <el-select
            v-model="DuiHuanList"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请选择兑换商品"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in storegoodslist"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>

            </el-option>
          </el-select>

        </el-form-item>




        <el-form-item label="购买商品数" prop="discount"
                      v-if="form.type == 'BuyActivity'">
          <el-input v-model="BuyNumber" placeholder="请输入购买商品数" style="width: 200px" @input="ChangeBuyDiscount"/>
          件
        </el-form-item>
        <el-form-item label="选择购买商品" prop="storeId" v-if="form.type == 'BuyActivity'">
<!--          <el-select v-model="ChoiseBuyGoods.id" ref="select" placeholder="请选择购买商品" @change="ChangeBuyDiscount">-->
<!--            <el-option v-for="item in storegoodslist" :key="item.id" :label="item.name" :value="parseInt(item.id)">-->
<!--            </el-option>-->
<!--          </el-select>-->


          <el-select
            v-model="ChoiseBuyGoods.id"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请选择购买商品"
            @change="ChangeBuyDiscount"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in storegoodslist"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>
            </el-option>
          </el-select>


        </el-form-item>

        <el-form-item label="优惠商品数" prop="discount"
                      v-if="form.type == 'BuyActivity'">
          <el-input v-model="YouHuiNumber" placeholder="请输入优惠商品数" style="width: 200px"
                    @input="ChangeBuyDiscount"/>
          件
        </el-form-item>
        <el-form-item label="选择优惠商品数" prop="storeId" v-if="form.type == 'BuyActivity'">
<!--          <el-select v-model="ChoiseSonGoods.id" ref="select" placeholder="请选择优惠商品数"-->
<!--                     @change="ChangeBuyDiscount">-->
<!--            <el-option v-for="item in storegoodslist" :key="item.id" :label="item.name" :value="parseInt(item.id)">-->
<!--            </el-option>-->
<!--          </el-select>-->


          <el-select
            v-model="ChoiseSonGoods.id"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请选择优惠商品数"
            @change="ChangeBuyDiscount"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in storegoodslist"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>

            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠商品打" prop="discount"
                      v-if="form.type == 'BuyActivity'">
          <el-input v-model="ZheKouNumber" placeholder="请输入优惠商品折扣" style="width: 200px"
                    @input="ChangeBuyDiscount"/>
          折
        </el-form-item>
        <el-form-item label="描述：" prop="discount"
                      v-if="form.type == 'BuyActivity'">
          {{ Buydiscount }}
        </el-form-item>

        <el-form-item label="活动开始的时间" prop="startTime">
          <el-date-picker clearable
                          v-model="form.startTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择活动开始的时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动结束的时间" prop="endTime">
          <el-date-picker clearable
                          v-model="form.endTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择活动结束的时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="优惠对象" prop="target">

          <el-select v-model="form.target" ref="select" placeholder="请选择优惠对象">
            <el-option
              v-for="item in optionstarget"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否开启周期活动" prop="periodic" v-if="!(form.type==='offerCoinCoupons' ||form.type==='offerFoldCoupons'||form.type==='offerMinusCoupons' || form.type==='offerYeCoinCoupons'|| form.type==='YeofferCoinCoupons')">
          <el-select v-model="form.periodic" ref="select" placeholder="请选择是否开启周期活动">
            <el-option
              v-for="item in optionsperiodic"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期活动类型" prop="periodic" v-if="form.periodic==1">
          <el-select v-model="form.periodType" ref="select" placeholder="请选择周期活动类型"
                     @change="changeSelectZhouQi">
            <el-option
              v-for="item in optionsperiodType"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="周期活动的起始时间" prop="periodStartTime"
                      v-if="form.periodic==1 && form.periodType=='day'">

          <el-time-picker
            v-model="form.periodStartTime"
            placeholder="请选择周期活动的起始时间">
          </el-time-picker>

        </el-form-item>
        <el-form-item label="周期活动的结束时间" prop="periodEndTime" v-if="form.periodic==1 && form.periodType=='day'">
          <el-time-picker
            v-model="form.periodEndTime"
            placeholder="请选择周期活动的结束时间">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="执行日期" prop="periodic" v-if="form.periodType=='week' || form.periodType=='month'">
          <el-select v-model="form.periodDay" ref="select" placeholder="请选择周期活动执行日期" multiple>
            <el-option
              v-for="item in priceList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="会员是否积分" prop="earnPoints" v-if="form.type=='vip_active'">
          <el-select v-model="form.earnPoints" ref="select" placeholder="请选择会员是否获得积分的标识">
            <el-option
              v-for="item in optionsperiodic"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额积分比" prop="discount" v-if="form.type=='vip_active'">
          <el-input v-model="VipMoney" placeholder="请输入金额" style="width: 200px"/>
          (元)
          <span>
            比
          </span>
          <el-input v-model="VipFen" placeholder="请输入积分" style="width: 200px"/>
          (积分)
        </el-form-item>


        <el-form-item
          v-for="(domain, index) in form.yzsActivityRuleList"
          :label="form.type != 'specialActivity'?'优惠层级' + (index+1):'特价商品' + (index+1)"
          v-if="form.type == 'FullMinusActivity' || form.type == 'fullFoldActivity' || form.type == 'specialActivity' || form.type == 'offerYeCoinCoupons'"
          :key="domain.key">

          <div style="display: flex;gap: 60px;">
            <div v-if="form.type == 'FullMinusActivity' || form.type == 'fullFoldActivity'">
              <el-select v-model="domain.thresholdUnit" ref="select" placeholder="请选择优惠层级单位"
                         @change="NextBuZhou(domain,index)">
                <el-option
                  v-for="item in SelectDanWeiList"
                  :key="item.text"
                  :label="item.name"
                  :value="item.text">
                </el-option>
              </el-select>
              <span>
                满
                  <el-input v-model="domain.Buy" :placeholder="SelectYouHuiQuan==1?'请输入门槛金额':'请输入门槛件数'"
                            style="width: 170px" @input="NextBuZhou(domain,index)" type="number"/>
                    {{ domain.thresholdUnit == "满额" ? '元' : '件' }}，
                    <div>
                      {{ domain.operationType == "减" ? '减' : '打' }}
                  <el-input v-model="domain.ZheKou" :placeholder="SelectYouHui == 0?'请输入优惠金额':'请输入优惠折扣'"
                            style="width: 170px;margin-right: 10px" @input="NextBuZhou(domain,index)" type="number"/>
                     <el-select v-model="domain.operationType" ref="select" placeholder="请选择优惠单位"
                                @change="NextBuZhou(domain,index)">
                        <el-option
                          v-for="item in optionsYouHui"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                 </div>
              </span>
            </div>

            <div v-else-if="form.type == 'offerYeCoinCoupons'">
              商品：
<!--              <el-select v-model="domain.operationType" ref="select" placeholder="请选择兑换商品"-->
<!--                         @change="DuiHuanYeChange(domain)">-->
<!--                <el-option v-for="item in storegoodslist" :key="String(item.id)" :label="item.name"-->
<!--                           :value="String(item.id)">-->
<!--                </el-option>-->
<!--              </el-select>-->


              <el-select
                v-model="domain.operationType"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="请选择兑换商品"
                @change="DuiHuanYeChange(domain)"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in storegoodslist"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>

                </el-option>
              </el-select>


              兑换
              <el-input v-model="domain.presentType" placeholder="请输入商品特价" style="width: 200px" type="number"/>
              ml
            </div>
            <div v-else>
              商品：
<!--              <el-select v-model="domain.id" ref="select" placeholder="请选择特价商品">-->
<!--                <el-option v-for="item in storegoodslist" :key="item.id" :label="item.name" :value="parseInt(item.id)">-->
<!--                </el-option>-->
<!--              </el-select>-->


              <el-select
                v-model="domain.id"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="请选择特价商品"
                @change="DuiHuanYeChange(domain)"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in storegoodslist"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)">
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>

                </el-option>
              </el-select>


              打
              <el-input v-model="domain.LinSouJia" placeholder="请输入商品特价" style="width: 200px" type="number"/>
              折
            </div>
            <el-button @click.prevent="removeDomain(domain)" type="danger" plain>删除</el-button>
          </div>

        </el-form-item>

        <el-button @click="addDomain" type="primary" plain style="margin-bottom: 20px"
                   v-if="form.type == 'FullMinusActivity' || form.type == 'fullFoldActivity' || form.type == 'specialActivity' || form.type == 'offerYeCoinCoupons'"
        >{{ form.type != 'specialActivity' ? '增加优惠层级' : '增加特价商品' }}
        </el-button>


        <el-form-item label="可参与商品类型" prop="joinType">
          <el-select v-model="form.joinType" ref="select" placeholder="请选择参与活动商品类型">
            <el-option
              v-for="item in optionsjoinType"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="可参与商品列表" prop="periodic" v-if="form.joinType=='id'">
<!--          <el-select v-model="form.joinList" ref="select"-->
<!--                     placeholder="请选择参与活动商品列表" multiple>-->
<!--            <el-option-->
<!--              v-for="item in storegoodslist"-->
<!--              :key="item.id"-->
<!--              :label="item.name"-->
<!--              :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->

          <el-select
            v-model="form.joinList"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="可参与商品列表"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in storegoodslist"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>

            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item label="可参与商品列表" prop="periodic" v-if="form.joinType=='type'">
          <el-select v-model="form.joinList" ref="select" placeholder="请选择参与活动商品列表" multiple>
            <el-option
              v-for="item in optionsGoodsType"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>



        </el-form-item>





        <el-form-item label="不可参与商品类型" prop="periodic">
          <el-select v-model="form.unjoinType" ref="select" placeholder="请选择不可参与商品类型">
            <el-option
              v-for="item in optionsUnjoinType"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="不可参与商品列表" prop="periodic" v-if="form.unjoinType=='id'">
<!--          <el-select v-model="form.unjoinType" ref="select" placeholder="请选择不参与活动商品列表" multiple>-->
<!--            <el-option-->
<!--              v-for="item in storegoodslist"-->
<!--              :key="item.id"-->
<!--              :label="item.name"-->
<!--              :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <el-select
            v-model="form.unjoinType"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="可参与商品列表"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in storegoodslist"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">条码：{{ item.barcode }}</span>
            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item label="不可参与商品列表" prop="periodic" v-if="form.unjoinType=='type'">
          <el-select v-model="form.unjoinList" ref="select" placeholder="请选择不参与活动商品列表" multiple>
            <el-option
              v-for="item in optionsGoodsType"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="活动简介" prop="discount">
          <el-input v-model="form.note" placeholder="请输入活动简介" type="textarea"/>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {listActivity, getActivity, delActivity, addActivity, updateActivity} from "@/api/system/activity";
// import {listStore} from "@/api/business/store";
// import {listStoregoods} from "@/api/goodssys/storegoods";
import {
  Activity,
  Activity2,
  Activitydel,
  Activitylist,
  getGoodsList,
  getGoodsTypeList,
  getStoreList
} from "../../api/api";


export default {
  name: "Activity",

  data() {
    return {
      IsCoupons: false, // 是否是优惠劵

      optionsGoodsType: [],
      optionsUnjoinType: [
        {
          text: '无',
          name: '无',
          value: "none",
        },
        {
          text: '指定分类',
          name: '指定分类',
          value: "type",
        },
        {
          text: '指定商品',
          name: '指定商品',
          value: "id",
        },
      ],
      optionsjoinType: [
        {
          text: '全部商品',
          name: '全部商品',
          value: "all",
        },
        {
          text: '指定分类',
          name: '指定分类',
          value: "type",
        },
        {
          text: '指定商品',
          name: '指定商品',
          value: "id",

        },
      ],
      MenKanMoney: 0,
      storegoodslist: [],
      QuanMianMoney: 0,
      FaXinNumber: 0,
      LinQuHouWaitTime: "",
      YouXiaoQiTime: "",
      LinQuHouTime: "",
      YonQuanTime: 0,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 活动基本信息表表格数据
      activityList: [],


      BuyNumber: '', //买送活动，输入买n件
      ZheKouNumber: '', // 买送活动，输入折扣数
      ChoiseBuyGoods: {
        name: ''
      }, // 买送活动选择的商品
      ChoiseSonGoods: {
        name: ''
      }, // 买送活动送的商品
      YouHuiNumber: '', // 优惠商品数
      Buydiscount: '买n件a商品，m件b商品打s折', // 买送活动，输入折扣数

      optionstarget: [
        {
          id: "all",
          name: "所有人"
        },
        {
          id: "vip",
          name: "会员"
        },
        {
          id: "novip",
          name: "非会员"
        }
      ],
      optionsperiodType: [
        {
          id: "day",
          name: "每天"
        },
        {
          id: "week",
          name: "每周"
        },
        {
          id: "month",
          name: "每月"
        },
      ],
      optionsperiodic: [
        {
          id: 1,
          name: "是"
        },
        {
          id: 0,
          name: "否"
        }
      ],
      SelectYouHui: "",
      optionsYouHui: [
        {
          id: "折",
          name: "折"
        },
        {
          id: "减",
          name: "元"
        }
      ],
      optionsdiscount: [

        {
          id: "AfterLogin",
          name: "新用户注册后发送"
        },
        // {
        //   id: "VoucherCollectionCenter",
        //   name: "领券中心发送"
        // },
        // {
        //   id: "OldUser",
        //   name: "老用户发送"
        // },
        {
          id: "intoMiniProgram",
          name: "进入小程序就发送"
        },
        // {
        //   id: "AfterOpenDoor",
        //   name: "开门后发送"
        // },
        {
          id: "AfterBecameVIP",
          name: "成为会员后发送"
        },
        {
          id: "AfterVipConsume",
          name: "会员消费后发送"
        },
        {
          id: "AfterScanCode",
          name: "扫码、分享群领取"
        },
        {
          id: "AfterRecharge",
          name: "充值后赠送"
        },

      ],
      options: [
        {
          id: "vip_active",
          name: "会员活动"
        },

        {
          id: "specialActivity",
          name: "特价活动"
        },
        {
          id: "discount",
          name: "折扣活动"
        },
        {
          id: "offerCoinCoupons",
          name: "兑换券"
        },

        {
          id: "offerFoldCoupons",
          name: "折扣券"
        },
        {
          id: "offerMinusCoupons",
          name: "满减券"
        },
        {
          id: "FullMinusActivity",
          name: "满减活动"
        },
        {
          id: "fullFoldActivity",
          name: "满折活动"
        },
        {
          id: "BuyActivity",
          name: "第n件促销"
        },
      ],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        thresholdCoupon: null,
        storeId: null,
        note: null,
        type: null,
        discount: null,
        startTime: null,
        endTime: null,
        target: null,
        periodic: null,
        periodType: null,
        periodStartTime: null,
        periodEndTime: null,
        earnPoints: null,
        activityName: null,
        createdBy: null,
        createdTime: null,
      },
      // 表单参数
      form: {
        discount: "",
        type: "",
        target: "all", // 表示优惠对象，可以是 "all"（所有人）、"vip"（会员）或 "unvip"（非会员）。
        periodic: 0, // 表示是否开启周期活动，0:否，1：是
        periodType: "", // 表示周期方式，例如按天、按周、按月等
        periodStartTime: "", // 表示周期开始和结束时间
        periodEndTime: "",
        periodDay: "", // 记录周期活动指定的日份或星期的天数
        earnPoints: "1", // 表示会员是否获得积分的标识，0:否，1：是
        activityName: "", // 用于记录活动的名称或标题
        joinType: "all", // 可参与类型
        joinList: "", // 可参与列表
        unjoinType: "none", // 不可参与类型
        unjoinList: "", // 不可参与列表
        yzsActivityRuleList: [
          {
            thresholdUnit: '', //满额单位：记录满额的单位，如 "额" 或 "件
            operationType: '', // 操作类型: 表示操作类型，如减（满减）、折（满折）或增（满赠）
            ruleField: '', //  规则字段：记录具体的规则字段，如 "10:10" 表示满10加10分
            level: '', // 层级：表示第几层级
            relatedId: "",
            presentType: "",
            presentId: "",
          },
        ],
      },
      // 表单校验
      rules: {},
      storeList: [],
      storeIds: null,
      VipMoney: 0,
      VipFen: 0,
      priceList: [],
      SelectYouHuiQuan: "",
      SelectDanWeiList: [{
        text: '满额',
        name: '满指定金额',
        value: 1,
      },
        {
          text: '满件',
          name: '满指定件数',
          value: 2,
        },],
      YonQuanTimeDesc: "",
      QCZheKou: 0,
      QCMenKan: 0,
      DuiHuanNumber: 0,
      DuiHuanList: [],
    };
  },
  created() {
    this.getList();
    this.getStoreLists()
    this.goodsTypeQuery()
    // this.getStoreList();
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        let a = {
          name:query,
          pageNo:1,
          pageSize:30,
          storeId:localStorage.getItem("storeId"),
          typeId:"",
          }
        getGoodsList(a).then(res=>{
          console.log(res)
          this.storegoodslist = res.data.data.records
          this.loading = false;
        })

        // setTimeout(() => {
        //   this.loading = false;
        //   this.options = this.list.filter(item => {
        //     return item.label.toLowerCase()
        //       .indexOf(query.toLowerCase()) > -1;
        //   });
        // }, 200);
      } else {
        this.options = [];
      }
    },
    getStoreLists() {
      getStoreList().then((res) => {
        // this.storeList = res.data;
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        this.storeList = res.data;


      });
    },
    changeGoodsList() {

    },
    goodsTypeQuery() { // 类别
      this.list = []
      this.list1 = []
      getGoodsTypeList().then(res => {

        if (res.code == '0') {
          res.data.forEach(i => {
            let a = {
              "value": i.id,
              "label": i.name,
            }
            this.list.push(a)
            this.list1.push(a)
          })
          this.optionsGoodsType = res.data
        } else {

        }
      })
    },
    ChangeBuyDiscount() {
      this.storegoodslist.forEach(item => {
        console.log(item)
        if (item.id == this.ChoiseBuyGoods.id) {
          this.ChoiseBuyGoods.name = item.name
        }
        if (item.id == this.ChoiseSonGoods.id) {
          this.ChoiseSonGoods.name = item.name
        }
      })
      console.log(this.ChoiseBuyGoods)
      console.log(this.ChoiseSonGoods)
      this.Buydiscount = "买" + this.BuyNumber + "件" + this.ChoiseBuyGoods.name + "，" + this.YouHuiNumber + "件" +
        this.ChoiseSonGoods.name + "打" + this.ZheKouNumber + "折"

    },
    DuiHuanChange() {
      this.storegoodslist = [];

      let storeIds;
      if (this.form.type === 'offerCoinCoupons' || this.form.type === 'offerFoldCoupons' || this.form.type === 'offerMinusCoupons' || this.form.type === 'offerYeCoinCoupons' || this.form.type === 'YeofferCoinCoupons') {
        storeIds = this.form.periodDay
      } else {
        storeIds = this.form.storeId
      }
      console.log(storeIds)
      // if (storeIds.indexOf(',') != -1) {
      //   storeIds = storeIds.split(',')
      // } else {
      //   storeIds = [storeIds]
      // }
      storeIds.forEach(item => {
        let queryParams
        if (this.form.type == "offerCoinCoupons") {
          queryParams = {
            pageNum: 1,
            pageSize: 10000,
            storeId: item,
            goodsType: 0,
          }
        } else if (this.form.type == "YeofferCoinCoupons") {
          queryParams = {
            pageNum: 1,
            pageSize: 10000,
            storeId: item,
            goodsType: 1,
          }
        } else {
          queryParams = {
            pageNum: 1,
            pageSize: 10000,
            storeId: item,
          }
        }

        // listStoregoods(queryParams).then(response => {
        //
        //   response.rows.forEach(item => {
        //     this.storegoodslist.push(item);
        //
        //   })
        //   if (this.form.type == "YeofferCoinCoupons") {
        //     this.storegoodslist.forEach(item => {
        //       if (item.id ==  this.form.yzsActivityRuleList[0].operationType) {
        //         console.log(item)
        //         this.DuiHuanNumber = this.form.yzsActivityRuleList[0].ruleField * item.unit
        //       }
        //     })
        //
        //     this.DuiHuanList = String(this.form.yzsActivityRuleList[0].operationType)
        //   }
        //   this.$forceUpdate()
        //   if (this.form.type == 'BuyActivity')
        //     this.ChangeBuyDiscount()
        // });
      })

    },
    /** 查询活动基本信息表列表 */
    getList() {
      this.loading = true;
      let a = {
        storeId:localStorage.getItem("storeId")
      }
      Activitylist(a).then(response => {
        this.activityList = response.data.data;

        console.log(this.activityList)
        // this.total = response.total;
        this.loading = false;
        this.$forceUpdate()
      });
    },
    /** 查询售液机列表 */

    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      let type
      if(this.form.type !=null)
        type= JSON.parse(JSON.stringify(this.form.type));
      this.form = {
        activityId: null,
        thresholdCoupon: null,
        storeId: null,
        note: null,
        type: null,
        discount: "",
        startTime: null,
        endTime: null,
        target: "all", // 表示优惠对象，可以是 "all"（所有人）、"vip"（会员）或 "unvip"（非会员）。
        periodic: 0, // 表示是否开启周期活动，0:否，1：是
        periodType: "", // 表示周期方式，例如按天、按周、按月等
        periodStartTime: "", // 表示周期开始和结束时间
        periodEndTime: "",
        periodDay: "", // 记录周期活动指定的日份或星期的天数
        earnPoints: "1", // 表示会员是否获得积分的标识，0:否，1：是
        activityName: "", // 用于记录活动的名称或标题
        joinType: "all", // 可参与类型
        joinList: "", // 可参与列表
        unjoinType: "none", // 不可参与类型
        unjoinList: "", // 不可参与列表
        yzsActivityRuleList: [
          {
            thresholdUnit: '', //满额单位：记录满额的单位，如 "额" 或 "件
            operationType: '', // 操作类型: 表示操作类型，如减（满减）、折（满折）或增（满赠）
            ruleField: '', //  规则字段：记录具体的规则字段，如 "10:10" 表示满10加10分
            level: '', // 层级：表示第几层级
            relatedId: "",
            presentType: "",
            presentId: "",
          },
        ],
      };
      this.form.type = type;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.activityId)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    changeSelectZhouQi() {
      if (this.form.periodType == "month") { // 每月执行

        this.priceList = []
        for (let i = 1; i < 32; i++) {
          let a = {
            value: i,
            label: i + "号"
          }
          this.priceList.push(a)
        }

      } else if (this.form.periodType == "week") { // 每周执行

        this.priceList = []
        for (let i = 1; i < 8; i++) {
          let a = {
            value: i,
            label: "周" + i
          }
          this.priceList.push(a)
        }
      } else { // 每天执行

      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加活动基本信息表";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const activityId = row.activityId || this.ids


      Activity(activityId).then(response => {
        console.log(response)
        this.form = response.data.desc;
        this.form.yzsActivityRuleList = response.data.data
        this.open = true;
        this.title = "修改活动基本信息表";


        if (this.form.periodType == "day") {
          this.form.periodStartTime = "2023-01-01T" + this.form.periodStartTime
          this.form.periodEndTime = "2023-01-01T" + this.form.periodEndTime
        }
        if (this.form.storeId) {
          let a = JSON.parse(JSON.stringify(this.form.storeId))
          this.form.storeId = []
          this.form.storeId.push(a)
        }
        if (this.form.type == "vip_active") {

          let ActivityRule = this.form.yzsActivityRuleList[0]
          let list = ActivityRule.ruleField.split(":")
          this.VipMoney = list[0]
          this.VipFen = list[1]
        }


        if (this.form.type == "discount") {
          this.QCZheKou = Number(this.form.discount) * 10
          this.QCMenKan = this.form.yzsActivityRuleList[0].ruleField
          if (this.form.yzsActivityRuleList[0].operationType == "减") {
            this.SelectYouHuiQuan = 1
          } else {
            this.SelectYouHuiQuan = 2
          }

        }

        if (this.form.type == "BuyActivity") {
          this.Buydiscount = this.form.presentType
          this.ZheKouNumber = Number(this.form.yzsActivityRuleList[0].operationType) * 10
          let list = this.form.yzsActivityRuleList[0].ruleField.split(":")
          this.BuyNumber = list[0]
          this.YouHuiNumber = list[1]

          this.Buydiscount = this.form.yzsActivityRuleList[0].presentType
          this.ChoiseBuyGoods.id = Number(this.form.yzsActivityRuleList[0].thresholdUnit)
          this.ChoiseSonGoods.id = Number(this.form.yzsActivityRuleList[0].presentId)
          // this.queryGoodsByBarcode(res.data.data[0].presentId, 4)
          // this.queryGoodsByBarcode(res.data.data[0].thresholdUnit, 3)
        }

        if (this.form.type == "offerFoldCoupons" || this.form.type ==
          "offerMinusCoupons" || this.form.type == "offerCoinCoupons" || this.form.type == "YeofferCoinCoupons") {
          this.YonQuanTimeDesc = this.form.yzsActivityRuleList[0].presentType
        this.IsCoupons = true;

          this.FaFanType = this.form.discount
          // if (this.FaFanType.indexOf("AfterRecharge") != -1) {
          //   this.ShowChonZhi = true
          //   this.ChonZhiPrice = this.form.periodType
          // }
          let FafanString = ""
          const idArray = this.form.discount.split(",");
          this.form.discount = idArray;


          this.FaXinNumber = this.form.yzsActivityRuleList[0].level
          if (this.form.periodDay.indexOf(",") != -1) {
            this.form.periodDay = JSON.parse(JSON.stringify(this.form.periodDay)).split(
              ",")
          } else {
            let a = []
            a.push(String(this.form.periodDay))
            this.form.periodDay = a
          }

          this.MenDian = JSON.parse(JSON.stringify(this.form.createdBy))
          this.ChonZhiNum = JSON.parse(JSON.stringify(this.form.updateBy))

          this.form.createBy = ''

          let listR2 = this.form.yzsActivityRuleList[0].ruleField.split(":")
          if (this.form.yzsActivityRuleList[0].operationType == "减") {
            this.QuanMianMoney = listR2[1]
            this.MenKanMoney = listR2[0]

          } else {
            this.QuanMianMoney = listR2[1] * 10
            this.MenKanMoney = listR2[0]
          }
          if (this.form.yzsActivityRuleList[0].thresholdUnit == '满件') {
            this.SelectYouHuiQuan = 2
          } else {
            this.SelectYouHuiQuan = 1
          }


          if (this.form.type == "offerCoinCoupons") {
            this.DuiHuanNumber = this.form.yzsActivityRuleList[0].ruleField


            this.DuiHuanList = []
            if (this.form.yzsActivityRuleList[0].operationType.indexOf(",") != -1) {
              this.DuiHuanList = this.form.yzsActivityRuleList[0].operationType.split(",")
              this.DuiHuanList.forEach((item) => {
                Number(item)
              })
            } else {
              this.DuiHuanList.push(Number(this.form.yzsActivityRuleList[0].operationType))
            }
          }


          let persentIdString = this.form.yzsActivityRuleList[0].presentId

          if (persentIdString.includes("&")) {
            this.YonQuanTime = 0
            let persentIdList1 = persentIdString.split("&")
            // this.YonQuanTime = persentIdList1[0]

            if (persentIdString.includes(":")) {
              this.YonQuanTime = 2
              let persentIdList2 = persentIdList1[1].split(":")
              this.LinQuHouWaitTime = persentIdList2[0]
              this.YouXiaoQiTime = persentIdList2[1]
            } else {
              this.LinQuHouTime = persentIdList1[1]
            }

          } else {
            this.YonQuanTime = 1
            // this.YonQuanTime = persentIdString
          }

        }

        if (this.form.joinType == 'id' || this.form.unjoinType == 'type') {
          this.SelectJoin = 3
          this.ZhiDingShangPing = true
          this.ShowNOJoin = false

          if (this.form.type == "specialActivity") {
            this.form.yzsActivityRuleList.forEach(item => {
              // this.queryGoodsByBarcode(item.presentId, 1, item.ruleField)

              // res.data.JinHuoJia = (Number(res.data.salePrice) * Number(ruleField)).toFixed(
              //   2)
              item.id = Number(item.presentId)
              item.LinSouJia = Number(item.ruleField) * 10 // 折扣
              // res.data.RuKuNum = (Number(res.data.salePrice) * Number(ruleField)).toFixed(2)
            })

          } else {
            let array1;
            if (this.form.joinList.includes(",")) {
              array1 = this.form.joinList.split(",");
              this.form.joinList = array1
              // array1.forEach(item => {
              //   this.queryGoodsByBarcode(item, 1)
              // })
            } else {
              let a = []
              a.push(this.form.joinList)
              this.form.joinList = a
              // this.queryGoodsByBarcode(this.form.unjoinList, 1)
            }
          }
        }

        if (this.form.unjoinType == 'id' || this.form.unjoinType == 'type') {
          this.SelectJoin1 = 3
          this.ZhiDingShangPing = true
          this.ShowSheZhiZheKou = true
          let array1;
          if (this.form.unjoinList.includes(",")) {
            array1 = this.form.unjoinList.split(",");
            this.form.unjoinList = array1
            // array1.forEach(item => {
            //   this.queryGoodsByBarcode(item, 1)
            // })
          } else {
            let a = []
            a.push(this.form.unjoinList)
            this.form.unjoinList = a
            // this.queryGoodsByBarcode(this.form.unjoinList, 1)
          }
        }


        if (this.form.type == "fullFoldActivity" || this.form.type == "FullMinusActivity") {
          this.form.yzsActivityRuleList.forEach(item => {
            item.Buy = item.ruleField.split(":")[0]

            if(item.operationType =="减"){
              item.ZheKou = item.ruleField.split(":")[1]

            }else
            item.ZheKou = item.ruleField.split(":")[1] * 10


          })
        }

        console.log(this.form)

        // this.DuiHuanChange()


        this.$forceUpdate();
      });
    },


    NextBuZhou(item, index) {
      if (this.current == 0) {
        if (item.operationType == "折" && item.Buy != '') {
          item.ruleField = item.Buy + ":" + item.ZheKou / 10
          item.presentType = "满" + item.Buy + "元打" + item.ZheKou + "折"
          item.level = index + 1
        } else if (item.operationType == "减" && item.Buy != '') {
          item.ruleField = item.Buy + ":" + item.ZheKou
          item.presentType = "满" + item.Buy + "元减" + item.ZheKou + "元"
          item.level = index + 1
        }

      } else {

        if (item.operationType == "折" && item.Buy != '') {
          item.ruleField = item.Buy + ":" + item.ZheKou / 10
          if (this.type != 'BuyActivity') {
            item.presentType = "满" + item.Buy + "件打" + item.ZheKou + "折"
          } else {
            item.presentType = "第" + item.Buy + "件" + item.ZheKou + "折"
          }
          item.level = index + 1
        } else if (item.operationType == "减" && item.Buy != '') {
          item.ruleField = item.Buy + ":" + item.ZheKou
          if (this.type != 'BuyActivity') {
            item.presentType = "满" + item.Buy + "件减" + item.ZheKou + "元"
          } else {
            item.presentType = "第" + item.Buy + "件" + item.ZheKou + "元"
          }
          item.level = index + 1
        }

        console.log(item);

      }
      this.$forceUpdate()

      // uni.navigateBack(1)
    },


    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // if (this.form.activityId != null) {
          //   updateActivity(this.form).then(response => {
          //     this.$modal.msgSuccess("修改成功");
          //     this.open = false;
          //     this.getList();
          //   });
          // } else {
          let form = JSON.parse(JSON.stringify(this.form))

          if (this.form.type == "offerMinusCoupons" || this.form.type == "offerFoldCoupons" ||
            this.form.type == "offerCoinCoupons" || this.form.type == "offerYeCoinCoupons"|| this.form.type == "YeofferCoinCoupons") {
            // 优惠券就不用遍历门店id了
            form.periodDay = form.periodDay.join(",")
            form.storeId = null
            this.Save(form)
          } else {
            let storeIdList = JSON.parse(JSON.stringify(this.form.storeId))
            storeIdList.forEach(item => {
              setTimeout(() => {
                form.storeId = item
                this.Save(form)
              }, 200)
            })

          }

          // }
        }
      });
    },

    Save(form) {
      let this_ = this
      let ActivityData = JSON.parse(JSON.stringify(form))
      let ActivityRule = JSON.parse(JSON.stringify(form.yzsActivityRuleList))
      let ShanPinList = ActivityData.yzsActivityRuleList


      console.log(ActivityData.joinList)
      if (ActivityData.joinList)
        ActivityData.joinList = ActivityData.joinList.join(',')
      if (ActivityData.unjoinList)
        ActivityData.unjoinList = ActivityData.unjoinList.join(',')

      if (ActivityData.periodType == "day") {
        ActivityData.periodStartTime = ActivityData.periodStartTime.split("T")[1].slice(0, 8)
        ActivityData.periodEndTime = ActivityData.periodEndTime.split("T")[1].slice(0, 8)
      }

      if (ActivityData.type == "vip_active") {
        // 会员活动
        ActivityData.yzsActivityRuleList = []
        ActivityRule = {}
        ActivityRule.level = -1
        ActivityRule.operationType = "增"
        ActivityRule.thresholdUnit = "额"
        ActivityData.discount = "Full_amount" // 满额满减
        ActivityData.target = "vip"
        ActivityRule.ruleField = this.VipMoney + ":" + this.VipFen

        ActivityData.yzsActivityRuleList.push(ActivityRule)
      }

      if (ActivityData.type == "specialActivity" && ShanPinList.length != 0) {
        // 特价活动特殊处理
        ActivityData.joinType = "id" // 特价活动只选参与的商品
        if (ActivityData.joinType == "id" && ShanPinList.length != 0) {
          let joinList = []
          ActivityData.yzsActivityRuleList = []

          ShanPinList.forEach(item => {
            item.presentType = "特价活动，" + item.id + "商品打" + item.LinSouJia + "折"
            item.ruleField = item.LinSouJia / 10 // 折扣数
            item.presentId = item.id // 商品id


            joinList.push(item.id)


          })

          ActivityData.yzsActivityRuleList = ShanPinList
          ActivityData.joinList = joinList.join(',')


        } else {

          return;
        }

      } else if (ActivityData.type == "discount") {
        // 特价活动只有不参与商品
        if (this.QCZheKou == null) {

          return;
        }
        let BuyActivityList = {}
        // let joinList = []
        // if (ShanPinList.length != 0) {
        // 	ShanPinList.forEach(item => {
        // 		joinList.push(item.id)
        // 	})
        // 	ActivityData.unjoinList = joinList.join(',')
        // }
        // ActivityData.joinType = "all"
        ActivityData.discount = this.QCZheKou / 10


        if (this.SelectYouHuiQuan == 1) {
          //  满额券
          BuyActivityList.thresholdUnit = "满额"
        } else if (this.SelectYouHuiQuan == 2) {
          //  满件券
          BuyActivityList.thresholdUnit = "满件"
        }
        BuyActivityList.ruleField = this.QCMenKan

        // 发放方式
        ActivityData.yzsActivityRuleList = []
        ActivityData.yzsActivityRuleList.push(BuyActivityList)

      }

      // if (ActivityData.type == "FullMinusActivity" || ActivityData.type == "fullFoldActivity" ||
      //   ActivityData.type == "offerMinusCoupons" || ActivityData.type == "offerCoinCoupons" ||
      //   ActivityData.type == "offerFoldCoupons" ||
      //   ActivityData.type == "vip_active" || ActivityData.type == "BuyActivity" || ActivityData.type == "discount") {
      //   // 满额满级活动，对商品进行限制
      //
      //   if (ActivityData.joinType == "id" && ShanPinList.length != 0) {
      //     let joinList = []
      //     ShanPinList.forEach(item => {
      //       joinList.push(item.id)
      //     })
      //     ActivityData.joinList = joinList.join(',')
      //   }
      //   if (ActivityData.unjoinType == "id" && ShanPinList.length != 0) {
      //     let joinList = []
      //     ShanPinList.forEach(item => {
      //       joinList.push(item.id)
      //     })
      //     ActivityData.unjoinList = joinList.join(',')
      //   }
      // }

      console.log(1111, ActivityData);
      if (ActivityData.type == "BuyActivity") {
        let BuyActivityList = {}

        BuyActivityList.thresholdUnit = this.ChoiseBuyGoods.id
        BuyActivityList.presentId = this.ChoiseSonGoods.id
        BuyActivityList.operationType = this.ZheKouNumber / 10
        BuyActivityList.ruleField = this.BuyNumber + ":" + this.YouHuiNumber
        BuyActivityList.presentType = "买" + this.BuyNumber + "件" + this.ChoiseBuyGoods.name + "，" +
          this
            .YouHuiNumber + "件" + this.ChoiseSonGoods.name + "打" + this.ZheKouNumber + "折"
        BuyActivityList.level = 1

        if (ActivityData.yzsActivityRuleList.length != 0) {
          BuyActivityList.relatedId = ActivityData.yzsActivityRuleList[0].relatedId
          BuyActivityList.ruleId = ActivityData.yzsActivityRuleList[0].ruleId
        }


        ActivityData.yzsActivityRuleList = []
        ActivityData.yzsActivityRuleList.push(BuyActivityList)
      }


      if (ActivityData.type == "offerMinusCoupons" ||
        ActivityData.type == "offerFoldCoupons" || ActivityData.type == "offerCoinCoupons" || this.form.type == "offerYeCoinCoupons" || ActivityData.type == "YeofferCoinCoupons") {
        let BuyActivityList = {};

        if(this.form.type !="offerYeCoinCoupons"){

        // 满减券、折扣券
        if (ActivityData.yzsActivityRuleList.length == 0) {
          BuyActivityList = {}
        } else {
          BuyActivityList = JSON.parse(JSON.stringify(ActivityData.yzsActivityRuleList[0]))
        }

        this.Pop3QueDing()

          BuyActivityList.presentType = this.YonQuanTimeDesc

          if (this.YonQuanTime == 1) {
            // 指定时间可用
            BuyActivityList.presentId = this.YonQuanTime
          } else if (this.YonQuanTime == 2) {
            BuyActivityList.presentId = this.YonQuanTime + "&" + this.LinQuHouWaitTime + ":" + this
              .YouXiaoQiTime

          } else if (this.YonQuanTime == 0) {
            BuyActivityList.presentId = this.YonQuanTime + "&" + this.LinQuHouTime
          }
          BuyActivityList.level = this.FaXinNumber

        // if (this.form.discount.indexOf("AfterRecharge") != -1) {
        //   this.form.periodType = this.ChonZhiPrice
        // }
        }


        if (ActivityData.type == "offerMinusCoupons" ||
          ActivityData.type == "offerFoldCoupons") {


          if (this.SelectYouHuiQuan == 1) {
            //  满额券
            BuyActivityList.thresholdUnit = "满额"
          } else if (this.SelectYouHuiQuan == 2) {
            //  满件券
            BuyActivityList.thresholdUnit = "满件"
          }

          if (ActivityData.type == "offerFoldCoupons") {
            // 折扣券
            BuyActivityList.ruleField = this.MenKanMoney + ":" + (Number(this.QuanMianMoney) / 10)
              .toString()
            BuyActivityList.operationType = "折"
          } else {
            // 满减券
            BuyActivityList.operationType = "减"
            BuyActivityList.ruleField = this.MenKanMoney + ":" + this.QuanMianMoney
          }
          // 发放方式
          ActivityData.yzsActivityRuleList = []
          ActivityData.yzsActivityRuleList.push(BuyActivityList)
        }
        if (ActivityData.type == "offerCoinCoupons" || this.form.type == "YeofferCoinCoupons") {
          let idString = ""
          let idList = []
          if (ActivityData.type == "offerCoinCoupons"){
            if (this.DuiHuanList.length == 0) {

              return;
            }
            // let DuiHuanList2 = []
            this.DuiHuanList.forEach(item => {
              idList.push(item)
              // DuiHuanList2.push(item.name)
            })
            idString = idList.join(",")
            BuyActivityList.ruleField = this.DuiHuanNumber

          }else {
            idString = this.DuiHuanList
            this.storegoodslist.forEach(item => {
              if (item.id == this.DuiHuanList) {
                console.log(item)
                BuyActivityList.ruleField = this.DuiHuanNumber  / item.unit
              }
            })
          }


          BuyActivityList.operationType = idString
          BuyActivityList.thresholdUnit = "兑换"
          // BuyActivityList.operationType = "可兑换商品：" + DuiHuanList2.join(",")
          ActivityData.yzsActivityRuleList = []
          ActivityData.yzsActivityRuleList.push(BuyActivityList)

        }

        if (ActivityData.type == "offerYeCoinCoupons") {
         let BuyActivityList = {}
          this.Pop3QueDing()

          BuyActivityList.presentType = this.YonQuanTimeDesc

          if (this.YonQuanTime == 1) {
            // 指定时间可用
            BuyActivityList.presentId = this.YonQuanTime
          } else if (this.YonQuanTime == 2) {
            BuyActivityList.presentId = this.YonQuanTime + "&" + this.LinQuHouWaitTime + ":" + this
              .YouXiaoQiTime

          } else if (this.YonQuanTime == 0) {
            BuyActivityList.presentId = this.YonQuanTime + "&" + this.LinQuHouTime
          }
          BuyActivityList.level = this.FaXinNumber

          BuyActivityList.ruleField = this.DuiHuanNumber
          BuyActivityList.thresholdUnit = "兑换"
          // BuyActivityList.operationType = "可兑换商品：" + DuiHuanList2.join(",")
          ActivityData.yzsActivityRuleList.unshift(BuyActivityList)

          // 液体商品
          ActivityData.yzsActivityRuleList.slice(1).forEach((item, index) => {
            // this.Pop3QueDing()
            // item.presentType = this.YonQuanTimeDesc
            if (this.YonQuanTime == 1) {
              // 指定时间可用
              item.presentId = this.YonQuanTime
            } else if (this.YonQuanTime == 2) {
              item.presentId = this.YonQuanTime + "&" + this.LinQuHouWaitTime + ":" + this
                .YouXiaoQiTime

            } else if (this.YonQuanTime == 0) {
              item.presentId = this.YonQuanTime + "&" + this.LinQuHouTime
            }
            item.ruleField = Number(item.presentType) / Number(item.unit)
            item.thresholdUnit = "兑换"
            item.level = index + 1
          })

        }

        ActivityData.discount = ActivityData.discount.join(",")
      }

      console.log(ActivityData)


      Activity2(ActivityData).then(response => {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.open = false;
        this.getList();
      });


    },

    DuiHuanYeChange(domain) {
      this.storegoodslist.forEach(item => {
        if (item.id == domain.operationType) {
          domain.unit = item.unit
        }
      })
    },

    /** 删除按钮操作 */
    handleDelete(row) {
      const activityIds = row.activityId || this.ids;
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Activitydel(activityIds)
            .then(res => {
              if (res.code==0) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      // const activityIds = row.activityId || this.ids;
      // this.$modal.confirm('是否确认删除活动基本信息表编号为"' + activityIds + '"的数据项？').then(function () {
      //   return delActivity(activityIds);
      // }).then(() => {
      //   this.getList();
      //   this.$modal.msgSuccess("删除成功");
      // }).catch(() => {
      // });
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('system/activity/export', {
        ...this.queryParams
      }, `activity_${new Date().getTime()}.xlsx`)
    },
    Pop3QueDing() {


      if (this.YonQuanTime == 1) {
        // 指定时间可用
        this.YonQuanTimeDesc = "活动时间内可用"
      } else if (this.YonQuanTime == 2) {
        this.YonQuanTimeDesc = "领取后等待" + this.LinQuHouWaitTime + "天可用，有效期" + this.YouXiaoQiTime + "天"
        this.LinQuHouTime = ""
      } else if (this.YonQuanTime == 0) {
        this.YonQuanTimeDesc = "领取后" + this.LinQuHouTime + "天内可用"
        this.LinQuHouWaitTime = ""
        this.YouXiaoQiTime = ""
      }
    },

    removeDomain(item) {
      var index = this.form.yzsActivityRuleList.indexOf(item)
      if (index !== -1) {
        this.form.yzsActivityRuleList.splice(index, 1)
      }
    },
    addDomain() {
      this.form.yzsActivityRuleList.push({
        value: '',
        key: Date.now()
      });
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/activity/index.vue